import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const outreachKickoffShiftSchema = z
    .object({
        shift_id: z.uuid(),
        patient_name: z.string().nullable().optional(),
        start_time_local: z.string().nullable().optional(),
        end_time_local: z.string().nullable().optional(),
    })
    .strip();

const outreachKickoffPayloadSchema = z
    .object({
        type: z.literal('outreach_kickoff').optional(),
        outreach_id: z.uuid(),
        shifts: z.array(outreachKickoffShiftSchema).optional(),
        callout_reason: z.string().nullable().optional(),
        instructions: z.string().nullable().optional(),
        simulation_mode: z.boolean().optional(),
        noop_writes: z.boolean().optional(),
        agent_drive_mode: z.boolean().optional(),
    })
    .strip();

export const outreachKickoffDefinitions = {
    outreach_kickoff: defineInvisible('outreach_kickoff', {
        disposition: 'invisible',
        schema: outreachKickoffPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const outreachKickoffContractFixtures = {
    valid: {
        type: 'outreach_kickoff',
        outreach_id: '00000000-0000-4000-8000-000000000001',
        shifts: [
            {
                shift_id: '00000000-0000-4000-8000-000000000002',
                patient_name: 'Internal patient name',
                start_time_local: '2026-08-28T09:00:00',
                end_time_local: '2026-08-28T17:00:00',
            },
        ],
        callout_reason: 'Internal callout reason',
        instructions: 'Internal outreach instructions',
        simulation_mode: false,
        noop_writes: false,
        agent_drive_mode: true,
    },
    malformed: {
        type: 'outreach_kickoff',
        outreach_id: 'not-a-uuid',
        shifts: [],
    },
} as const;
